// 规避sonar代码扫描
export default function safeInvoke(that: any, fn: Function, ...args: any[]) {
  return fn.apply(that, args);
}
